var _g, _rect, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicFolder(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_2653_79555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4025 4.94742C11.0225 4.56742 10.5125 4.35742 9.9825 4.35742H4.8125C3.7125 4.35742 2.8225 5.25742 2.8225 6.35742L2.8125 18.3574C2.8125 19.4574 3.7125 20.3574 4.8125 20.3574H20.8125C21.9125 20.3574 22.8125 19.4574 22.8125 18.3574V8.35742C22.8125 7.25742 21.9125 6.35742 20.8125 6.35742H12.8125L11.4025 4.94742Z",
    fill: "#565556"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10.7861,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#DAF4DF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2653_79555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 21.9521C16.6997 21.9521 14.833 20.0855 14.833 17.7855C14.833 15.4855 16.6997 13.6188 18.9997 13.6188C21.2997 13.6188 23.1663 15.4855 23.1663 17.7855C23.1663 20.0855 21.2997 21.9521 18.9997 21.9521ZM15.6663 17.7855C15.6663 18.0396 15.6997 18.2896 15.7538 18.5271L17.7455 16.5355V16.1188C17.7455 15.6605 18.1205 15.2855 18.5788 15.2855V14.4813C16.9413 14.6896 15.6663 16.0896 15.6663 17.7855ZM21.4538 15.5355C21.3455 15.873 21.0372 16.1188 20.6622 16.1188H20.2455V17.3688C20.2455 17.598 20.058 17.7855 19.8288 17.7855H17.3288V18.6188H18.1622C18.3913 18.6188 18.5788 18.8063 18.5788 19.0355V19.8688H19.4122C19.8705 19.8688 20.2455 20.2438 20.2455 20.7021V20.873C21.4663 20.3813 22.333 19.1813 22.333 17.7855C22.333 16.9188 21.9955 16.1271 21.4538 15.5355Z",
    fill: "#018001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2653_79555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.8125 0.357422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2653_79555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(1 0 0 -1 14 22.7861)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicFolder);
export default __webpack_public_path__ + "static/media/PublicFolder.2095cff0e1ae9933f3493661f3c2171c.svg";
export { ForwardRef as ReactComponent };